import React, { useEffect, useState } from 'react';
import ReactHtmlParser from 'react-html-parser';
import * as cnst from '@ts/consts';
/**
 * エクセルのシリアルタイムを変換する
 */
const excelSerialTimeToDateStr = (serialTime) => {
    const mSeconds = (serialTime - 25569) * 24 * 60 * 60 * 1000;
    const date = new Date(mSeconds);
    return `${date.getMonth() + 1}月${date.getDate()}日`;
};
const ShopItem = ({ shopItem }) => {
    const [openTime, setOpenTime] = useState('');
    const [closeTime, setCloseTime] = useState('shop-item');
    const [className, setClassName] = useState('');
    /**
     * ゴージャスグッズキャラバン対象店舗
     */
    useEffect(() => {
        if (shopItem.special !== undefined) {
            setClassName(`shop-item campaign`);
        }
        else {
            setClassName(`shop-item`);
        }
    }, [
        shopItem
    ]);
    /**
     * 開始終了日のセット
     */
    useEffect(() => {
        setOpenTime(excelSerialTimeToDateStr(Number(shopItem.open_date)));
        setCloseTime(excelSerialTimeToDateStr(Number(shopItem.close_date)));
    }, [
        shopItem
    ]);
    return (React.createElement("div", { className: className },
        React.createElement("a", { className: "shop-item-campaign", href: "./campaign.html" },
            React.createElement("img", { src: `./assets/img/misc/ico/campaign.png?${cnst.CACHEBUSTER}` })),
        React.createElement("div", { className: "shop-item-name" },
            React.createElement("a", { className: "text-link outside", href: shopItem.url, target: "_blank" }, shopItem.shop_name)),
        React.createElement("div", { className: "shop-item-info" },
            React.createElement("div", { className: "shop-item-period" },
                openTime,
                "\uFF5E",
                closeTime),
            shopItem.optional_text && (React.createElement("div", { className: "shop-item-note md:hidden" },
                React.createElement("div", { className: 'h-indent' }, ReactHtmlParser(shopItem.optional_text)))),
            React.createElement("div", { className: "shop-item-address" },
                React.createElement("div", null,
                    shopItem.adress,
                    shopItem.adress_option &&
                        (React.createElement("span", null,
                            " ",
                            shopItem.adress_option))),
                React.createElement("div", { className: "shop-item-tel" }, shopItem.tel_number))),
        shopItem.optional_text && (React.createElement("div", { className: "shop-item-note sm:hidden" },
            React.createElement("div", { className: 'h-indent' }, ReactHtmlParser(shopItem.optional_text))))));
};
export default ShopItem;
